import Vue from "vue";
import flatpickr from "flatpickr";
import { Russian } from "flatpickr/dist/l10n/ru";

import "./directives";
import "./components";
import "./validation";

if (window.AcademIt.Locale === "ru") {
    flatpickr.setDefaults({
        locale: Russian,
        altInput: true,
        altFormat: "d.m.Y",
        allowInput: true,
        disableMobile: true,
        minuteIncrement: 1,
        time_24hr: true
    });
} else {
    flatpickr.setDefaults({
        altInput: true,
        altFormat: "m/d/Y",
        allowInput: true,
        disableMobile: true,
        minuteIncrement: 1
    });
}

import Vuex from "vuex";
Vue.use(Vuex);

import VTooltip from "v-tooltip";
Vue.use(VTooltip);

import DialogsPlugin from "./dialogsPlugin";
Vue.use(DialogsPlugin);

import TextareaAutosize from "vue-textarea-autosize";
Vue.use(TextareaAutosize);

import { Chart } from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";

Chart.register(ChartDataLabels);